


















































































































































import { Component, Vue } from 'vue-property-decorator'
import Partner from '@/components/public/Partner.vue'
import buyApi from '@/api/buyApi'
import moment from 'moment'
import utils from '@/utils/utils.ts'
import listApi from '@/api/listApi'
/**
 * 完成订单
 */
@Component({
  components: {
    Partner,
  },
  filters: {
    formatYMD(value: any) {
      return moment(Number(value)).format('YYYY月MM日DD HH时mm分')
    }
  }
})

export default class Pay extends Vue {
  private purchaseInformation: any = {
    goldBalance: 0,
    silverBalance: 0
  }
  private password: any = ''
  private imgCodeStr: string = ''
  private coinType: string = 'GOLDCOINS'
  private deadTime: any = ''
  private orderNo: any = 'IN_ORD19012500002'
  private imgCode: string = ''
  private passwordError: boolean = false
  private residue: number = null
  private isLock: string = ''
  private authCode: string = ''
  private expireTime: number = null
  private boutiqueList: any[] = []
  // private
  public mounted() {
    this.orderNo = this.$route.query.orderNo
    this.getOrderMessage()
    this.getImgCode()
    this.getBoutique()
  }
  // 获取订单信息
  protected getOrderMessage() {
    buyApi.getOrderMessage({
      orderCode: this.orderNo
    }).then((res) => {
      if (res.code === 200) {
        this.purchaseInformation = res.data
        this.coinType = res.data.purchaseType
        this.residue = res.data.errorCount
        this.expireTime = res.data.expireTime
        if (res.data.purchaseType === 'GOLDORSILVER') {
          this.coinType = 'GOLDCOINS'
        }
        if (res.data.orderPayStatus === 'PASSWORD_LOCK') {
          this.isLock = 'lock'
        } else if (res.data.orderPayStatus === 'PASSWORD_ERROR') {
          this.isLock = 'passwordMistake'
        }
      }
    })
  }

  // 过滤输入框
  protected filterText() {
    // this.password = this.password.replace(/^(0+)|[^\d]+/g, '')
  }

  // 选择金币
  protected checkPrice(type: any) {
    this.coinType = type
  }

  // 忘记密码
  protected forget() {
    window.location.href = '/user/#/pay-password'
  }

  // 充值
  protected recharge() {
    window.location.href = '/user/#/finance-recharge'
  }

  // 获取图片验证码
  protected getImgCode() {
    buyApi.generatorImgCode().then((res) => {
      if (res.code === 200) {
        this.imgCode = res.data.authCodeGif
        this.authCode = res.data.authCode
      }
    })
  }

  // 点击在换一张验证码
  protected changeImgCode() {
    this.getImgCode()
  }

  // 点击支付
  protected pay() {
    if (this.isLock === 'lock') {
      return
    }
    if (this.password == '') {
      this.$warning({
        title: '提示',
        content: '请输入密码',
        okText: '知道了'
      });
      return false
    }
    if (this.orderNo !== '') {
      buyApi.pay({
        orderCode: this.orderNo,
        payPassword: this.password,
        coinType: this.coinType,
        imgCode: this.imgCodeStr || '',
        authCode: this.authCode || ''
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.orderPayStatus === 'SUCCESS') {
            this.$router.push({ name: 'conduct-pay', query: { orderNo: this.orderNo } })
          } else if (res.data.orderPayStatus === 'PASSWORD_ERROR') {
            this.$error({
              title: '提示',
              content: '密码输入错误',
            });
            this.passwordError = true
            this.isLock = 'passwordMistake'
            this.residue = res.data.errorCount
            this.getImgCode()
          } else if (res.data.orderPayStatus === 'PASSWORD_LOCK') {
            this.$error({
              title: '提示',
              content: '该账号已锁定，请等' + res.data.expireTime + '分钟后再尝试',
            });
            this.isLock = 'lock'
            this.passwordError = true
            this.expireTime = res.data.expireTime
            this.getImgCode()
          } else if (res.data.orderPayStatus === 'VERIFICATION_CODE_ERROR') {
            this.$error({
              title: '提示',
              content: '验证码输入错误,请重新输入',
            });
            this.isLock = ''
            this.getImgCode()
          }
        } else if (res.code === 263042) {
          this.$confirm({
            title: '未设置支付密码',
            content: res.msg,
            okText: '设置',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
              window.location.href = '/user/#/pay-password'
            },
          });
        } else if (res.code === 263044) {
          this.$error({
            title: '提示',
            content: res.msg,
          });
        } else if (res.code === 262516) {
          this.$warning({
            title: '提示',
            content: '尊敬的供应商，您单位账户酒币余额不足，请与您对接的供应链公司对接充值酒币。',
          });
          // this.$confirm({
          //   title: '酒币金额不足',
          //   content: res.msg,
          //   okText: '知道了',
          //   okType: 'primary',
          // cancelText: '取消',
          //   onOk() {
          // window.location.href = '/user/#/finance-recharge'
          //   },
          // });
        } else {
          this.$error({
            title: '错误',
            content: res.msg,
          });
        }
      })
    }

  }

  // 订单广告位展示
  protected getBoutique(): void {
    listApi.getHotList({
      businessType: 'PROMOTION',
      position: 'ORDER_PAY',
    }).then((res) => {
      if (res.code === 200 && res.data.length > 0) {
        this.boutiqueList = res.data
      }
    })
  }

}
